export default __webpack_public_path__ + "static/media/logo@2x.97c95168.png";